<div tabindex="0" [ngClass]="getOverlayClass(_box)" class="position-relative h-100">
  <ng-container [ngSwitch]="_box.Type">
    <app-text *ngSwitchCase="0" [box]="_box" [styleClasses]="getStyleClasses(_box)" [isAreaHero]="isAreaHero" [customStyle]="getCustomStyle(_box)"></app-text>
    <app-picture *ngSwitchCase="1" [box]="_box" [styleClasses]="getStyleClasses(_box)" [isAreaHero]="isAreaHero" [customStyle]="getCustomStyle(_box)"></app-picture>
    <app-video *ngSwitchCase="2" [box]="_box" [styleClasses]="getStyleClasses(_box)" [isAreaHero]="isAreaHero" [customStyle]="getCustomStyle(_box)"></app-video>
  </ng-container>
</div>
